import React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Avatar from '@mui/material/Avatar'
import ListItemAvatar from '@mui/material/ListItemAvatar'

interface RoundOrderEntry {
  participant: {
    id: string
    user: { id: string; name: string }
  }
  pickPosition: number
}

interface ScheduleSelectionRoundOrdersProps {
  roundOrders: RoundOrderEntry[][]
}

export default function ScheduleSelectionRoundOrders(
  props: ScheduleSelectionRoundOrdersProps,
): React.JSX.Element {
  const { roundOrders } = props

  return (
    <div>
      {roundOrders.map((round, roundIndex) => (
        <Accordion key={roundIndex} defaultExpanded={roundIndex === 0}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Round {roundIndex + 1}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense>
              {round
                .slice()
                .sort((a, b) => a.pickPosition - b.pickPosition)
                .map((entry) => (
                  <ListItem key={entry.participant.id}>
                    <ListItemAvatar>
                      <Avatar sx={{ width: 28, height: 28, fontSize: 14 }}>
                        {entry.pickPosition + 1}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={entry.participant.user.name} />
                  </ListItem>
                ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}
